import * as React from "react";
import { Button, Col, Row } from "reactstrap";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import {
    getCity,
    getRegion
} from "./TableUtils"
import { getMarketingMatch } from "../api/marketing"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const CampaignMatch = ({ campaign, initMatch }) => {
    const [matches, setMatches] = React.useState(initMatch || [])
    const [loading, setLoading] = React.useState(false)

    const loadMatches = async () => {
        try {
            setLoading(true)
            const res = await getMarketingMatch(campaign);
            setMatches(res)
        } finally {
            setLoading(false)
        }
    }
    return (
        <Col xs="12" className="mt-3">
            <h5 className="mt-2">Clienti coinvolti nella Campagna <Button onClick={loadMatches} color="warning" className="ml-2"><FontAwesomeIcon icon="sync" /> Cerca Clienti</Button></h5>
            <DataTable
                value={matches || []}
                paginator={true}
                autoLayout={false}
                loading={loading}
                className="p-datatable-hoverable-rows p-datatable-customers"
                emptyMessage={() => (<div className="text-center">Nessun Cliente in tabella</div>)}
                paginator
                paginatorTemplate="RowsPerPageDropdown CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink"
                currentPageReportTemplate="Visualizzati {first} di {last} Clienti su un totale di {totalRecords}"
            >
                <Column
                    field="name"
                    header="Cliente"
                    sortable
                    filter
                    filterMatchMode="contains"
                    style={{ wordWrap: "break-word" }}
                />
                <Column
                    field="email"
                    header="Email"
                    sortable
                    filter
                    style={{ wordWrap: "break-word" }}
                />
                <Column
                    field="plate"
                    header="Targa"
                    sortable
                    filter
                    style={{ wordWrap: "break-word" }}
                    body={(rowData, column) => {
                        return (
                            rowData.plate.toUpperCase()
                        );
                    }}
                />
                <Column
                    key="col-6"
                    field="address.region"
                    header="Regione"
                    style={{ wordWrap: "break-word" }}
                    sortable
                    body={getRegion}
                    filter={true}
                    filterMatchMode="contains"
                />
                <Column
                    key="col-6"
                    field="address.city"
                    header="Comune"
                    style={{ wordWrap: "break-word" }}
                    sortable
                    body={getCity}
                    filter={true}
                    filterMatchMode="contains"
                />
            </DataTable>
        </Col>
    );
};

export default CampaignMatch;
